export default __webpack_public_path__ + "static/media/knsLogoFullNameBg.01fce712.png";